


















































































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs,
  vue3Model
} from '~/utils/nuxt3-migration'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { toCamelCase } from '~/utils/object'
import { useLogger } from '~/compositions/logger'
import { useDep } from '~/compositions/dependency-container'
import LoanService from '~/services/loan/LoanService'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { SantanderTargetSchema } from '~/constants/loan/loans'
import { handleError } from '~/utils/http'
import { useI18n } from '~/compositions/i18n'
import { useSnackbar } from '~/compositions/snackbar'

export default defineComponent({
  components: {
    CFormError
  },
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    classifiedId: {
      type: Number,
      required: true
    },
    installments: {
      type: Number,
      required: true
    },
    downpayment: {
      type: [Number, String],
      required: true
    },
    averageInstallment: {
      type: Number,
      required: true
    },
    sessionId: {
      type: String,
      required: true
    },
    balloonAmount: {
      type: Number,
      required: false,
      default: undefined
    }
  },
  setup(props, { emit }) {
    const {
      installments,
      downpayment,
      classifiedId,
      averageInstallment,
      balloonAmount,
      sessionId
    } = toRefs(props)

    const schema = ref<SantanderTargetSchema | null>(null)
    const form = ref({})
    const errors = ref({})
    const submitbuttonRef = ref(null)
    const loading = ref(false)
    const targetUrl = ref('')

    const logger = useLogger()
    const snackbar = useSnackbar()
    const { t } = useI18n()
    const loanService = useDep(LoanService)

    const triggerSubmit = () => {
      if (submitbuttonRef.value) {
        submitbuttonRef.value.click()
      } else {
        onSubmit()
      }
    }

    const onSubmit = async () => {
      errors.value = {}
      try {
        loading.value = true
        const { url } = await loanService.getSantanderLoanTarget(
          classifiedId.value,
          form.value
        )

        if (url) {
          targetUrl.value = url
          window.open(url, '_blank')
          emit('target-url-success', url)
        }
      } catch (error) {
        if (error.response?.data?.data?.errors) {
          errors.value = toCamelCase(error.response.data.data.errors)
        } else {
          handleError(error, snackbar, logger, t)
        }
      } finally {
        loading.value = false
      }
    }

    const visible = computed({
      get() {
        return props.modelValue
      },
      set(value: boolean) {
        emit('update:modelValue', value)
      }
    })

    const fetchSchema = async () => {
      try {
        loading.value = true
        const {
          schema: fetchedSchema
        } = await loanService.getSantanderTargetUrlSchema(classifiedId.value)
        schema.value = fetchedSchema
      } catch (error) {
        if (error.response?.data?.data?.errors) {
          errors.value = toCamelCase(error.response.data.data.errors)
        }
        logger.captureError(error)
      } finally {
        loading.value = false
      }
    }

    onMounted(async () => {
      form.value = {
        client_identifier: sessionId.value,
        installment_amount: averageInstallment.value,
        balloon_amount: balloonAmount.value,
        installments: installments.value,
        downpayment: downpayment.value
      }
      await fetchSchema()
    })

    const onEnter = (e: Event) => {
      if (e.target.tagName.toLowerCase() !== 'textarea') {
        e.preventDefault()
        return false
      }
    }

    return {
      visible,
      schema,
      form,
      errors,
      loading,
      onSubmit,
      triggerSubmit,
      faCircleNotch,
      submitbuttonRef,
      targetUrl,
      onEnter
    }
  }
})
